module.exports = __webpack_public_path__ + "img/sce1.1fb2a29b.png";